import assert from 'http-assert-plus';

const PROD_ASSETS = 'https://real-links-assets.s3-eu-west-2.amazonaws.com';
const DEV_ASSETS = 'https://real-links-assets-dev.s3-eu-west-2.amazonaws.com';
const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export default function cdn(fileLocation, type, ...opts) {
  let prefix = '/cdn';

  assert(typeof fileLocation === 'string', new Error('Expected fileLocation to be a string'));
  assert(fileLocation.startsWith('http://') || fileLocation.startsWith('https://') || fileLocation.startsWith('/'),
    new Error('Expected fileLocation to start with: http:// https:// /'), { fileLocation });
  assert(!fileLocation.startsWith('/cdn'), new Error('fileLocation cannot start with /cdn'), { fileLocation });

  switch (type) {
    /**
     * Proxy an image through the CDN, to be cached
     * /cdn/:origin
     */
    case 'proxy': break;

    /**
     * Resize an image within the boundaries of width/height, preserving aspect ratio & ensuring the image covers the
     *   request dimensions by cropping/clipping to fit.
     * /cdn/1/:width/:height/:origin
     */
    case 'resize': {
      const [ width, height ] = opts;
      assert(typeof width === 'number' || typeof height === 'number', new Error('Resize expects width and/or height'));
      prefix += `/1/${width || 0}/${height || 0}`;
      break;
    }

    default: {
      throw new Error(`Unknown CDN transformation "${type}"`);
    }
  }

  if (IS_PRODUCTION && (fileLocation.startsWith(PROD_ASSETS) || fileLocation.startsWith(DEV_ASSETS))) {
    fileLocation = `assets${fileLocation.substr(fileLocation.indexOf('/', DEV_ASSETS.length + 1))}`;
  } else if (fileLocation.startsWith('https://')) {
    fileLocation = `https/${fileLocation.substr('https://'.length)}`;
  } else if (fileLocation.startsWith('http://')) {
    fileLocation = `http/${fileLocation.substr('http://'.length)}`;
  } else if (fileLocation.startsWith('/')) {
    fileLocation = fileLocation.substr(1);
  }

  return `${prefix}/${fileLocation}`;
};



// WEBPACK FOOTER //
// ./src/filters/cdn.js